import React from 'react';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import CircleInfoIcon from 'Assets/icons/circle-info.svg';
import HourglassIcon from 'Assets/icons/hourglass.svg';

function ExpenseFundApprovalsTableRow(props) {
    return (
        <tr key={props.expenseFundApproval.id} className="tw-cursor-pointer" onClick={props.clickHandler}>
            <td>{props.expenseFundApproval.expense ? props.expenseFundApproval.expense.name : '-'}</td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    {props.expenseFundApproval.status !== 'PENDING' ? (
                        <>
                            {props.expenseFundApproval.status === 'APPROVED' && <CircleCheckIcon className="tw-w-3 tw-h-3 tw-text-green" />}
                            {props.expenseFundApproval.status === 'REJECTED' && <CircleInfoIcon className="tw-w-3 tw-h-3 tw-text-red" />}
                        </>
                    ) : (
                        <HourglassIcon className="tw-w-3 tw-h-3 tw-text-blue" />
                    )}
                    {props.expenseFundApproval.status_label}
                </div>
            </td>
            <td>{props.expenseFundApproval.amount_data.totalDifference}</td>
        </tr>
    );
}

export default ExpenseFundApprovalsTableRow;
